<div class="fui-layout-pad-content">
  @if (!lesson) {
    <div class="video-rail-folder-header">
      <div class="video-rail-folder-header-row video-rail-title">
        <fui-heading class="video-rail-folder-title" level="5" [text]="title"></fui-heading>
        <span class="pill trans sm text-nowrap video-rail-count">{{ videos.length }} Videos</span>
        <button class="fui-action-btn sm video-rail-view-all" [attr.tabindex]="expanded ? 0 : -1" (click)="this.showMoreVideos.emit()">
          {{ "sphere.view_all" | translate }}
          <fa-icon icon="chevron-right"></fa-icon>
        </button>
      </div>
      @if (description && !isSmallViewport) {
        <span class="folder-description" [innerHTML]="description | safe: 'html'"></span>
      }
    </div>
  }
  @if (lesson) {
    <div class="fui-lesson-header m-b-30">
      <div class="lesson-image-container m-r-10" [ngStyle]="{ 'background-image': 'url(' + lesson.image + ')' }"></div>
      <div class="lesson-header-content">
        <div class="video-rail-title">
          <fui-heading level="5" [text]="lesson.title"></fui-heading>
        </div>
        <div class="lesson-header-meta">
          <span class="pill trans sm text-nowrap">{{ lesson.videos.length }} Videos</span>
          @if (lessonRuntimeLabel) {
            <span class="pill trans sm text-nowrap">{{ lessonRuntimeLabel }}</span>
          }
        </div>
        @if (isSmallViewport) {
          @if (lesson.snippet || lesson.description) {
            <span class="folder-description" [innerHTML]="lesson.snippet || lesson.description | safe: 'html'"></span>
          }
        } @else if (lesson.description) {
          <span class="folder-description" [innerHTML]="lesson.description | safe: 'html'"></span>
        }
        <div class="fui-action-btn-rail m-t-10" dragToScroll>
          <button class="fui-action-btn sm" [attr.tabindex]="expanded ? 0 : -1" [routerLink]="['/learn/lesson/', lesson.id]">
            {{ "video.view_lesson" | translate }}
            <fa-icon icon="chevron-right"></fa-icon>
          </button>
          <button class="fui-action-btn sm" [attr.tabindex]="expanded ? 0 : -1" (click)="toggleSaveLesson(lesson)">
            <fa-icon
              [animation]="togglingAddLessonToLibrary ? 'spin' : undefined"
              [icon]="togglingAddLessonToLibrary ? 'spinner' : contentService.userLearnData.lessons[lesson.id]?.enrolled ? 'minus' : 'plus'"
            ></fa-icon>
            {{ contentService.userLearnData.lessons[lesson.id]?.enrolled ? ("video.remove_from_library" | translate) : ("video.add_to_library" | translate) }}
          </button>
          <button class="fui-action-btn sm" [attr.tabindex]="expanded ? 0 : -1" (click)="copyLink(lesson)">
            <fa-icon [icon]="copied ? 'check' : 'link'"></fa-icon>
            {{ copied ? ("video.copied" | translate) : ("video.copy_link" | translate) }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
<div class="fui-layout-edge-content">
  <button
    type="button"
    class="video-rail-summary"
    [attr.aria-label]="railSummaryAriaLabel"
    [attr.aria-expanded]="expanded"
    [attr.tabindex]="expanded ? -1 : 0"
    (focus)="summaryFocused = true"
    (blur)="summaryFocused = false"
    (click)="enterRail()"
  ></button>
  <ul class="learn-list-horizontal-scroll video-grid" [class.no-left-margin]="!leftMargin" tabindex="-1" [attr.aria-hidden]="!expanded" preventHorizontalNav dragToScroll>
    @for (video of videos | slice: 0 : 10; track video; let i = $index) {
      <li>
        <myp-video-grid-item
          [video]="video"
          [tabIndex]="expanded ? 0 : -1"
          [isCardEntered]="enteredCardIndex === i"
          [itemIndex]="i + 1"
          [totalCount]="displayedVideoCount"
          (cardEntered)="onCardEntered(i)"
          (exited)="onCardExited()"
        ></myp-video-grid-item>
      </li>
    }
    @if (videos.length > 10) {
      <li class="show-more-button">
        <div class="text-center">
          <button type="button" class="fui-action-btn" [attr.tabindex]="expanded ? 0 : -1" (click)="this.showMoreVideos.emit()">
            {{ "video.show_more_videos" | translate }}
            <fa-icon icon="chevron-right" class="m-l-5"></fa-icon>
          </button>
          <div class="text-muted m-t-10">{{ videos.length }} Total Videos</div>
        </div>
      </li>
    }
  </ul>
</div>
